<template>
  <div class="headers">
    <div class="flexs a-center lefts j-center">
        <i class="imgs">
          <!-- <img id="img" v-if="domain>-1" src="@/assets/images/logo_times.svg" alt="Times E-Commerce Limited" > -->
          <img id="img" src="@/assets/images/logo.svg" alt="Kerry eCommerce Limited">
        </i>
    </div>
  </div>
</template>

<script>

  export default {
    name:'loginHeader',
    data () {
      return {
        domain:window.location.host.indexOf('stg.as2.kec-app.com')
      };
    },
    mounted(){
    },

  }

</script>
<style lang='stylus' scoped>
@import '~css/stylus.styl'
 .headers 
   height $headerHeight 
   box-shadow 0 2px 3px #999
   .lefts  
     height $headerHeight
     width 270px
     .imgs  
       height 50px
       img  
         height 100%
</style>



// WEBPACK FOOTER //
// src/pages/login/components/header.vue